var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "256px",
    height: "256px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M9,33a1,1,0,0,0,0-2,5,5,0,0,1-4.964-5.611A5.2,5.2,0,0,1,9.252,21,3.753,3.753,0,0,0,13,17.251V16.83a9.694,9.694,0,0,1,8.859-9.809,9.516,9.516,0,0,1,7.4,2.8,1,1,0,0,0,1.619-.285,9.486,9.486,0,0,1,17.573.794A1,1,0,0,0,49.39,11h.245A10.238,10.238,0,0,1,60,20.812,10,10,0,0,1,50,31H31a1,1,0,0,0,0,2h8V48H35a1,1,0,0,0-.707,1.707l10,10a1,1,0,0,0,1.414,0l10-10A1,1,0,0,0,55,48H51V32.951A11.988,11.988,0,0,0,62,20.776,12.235,12.235,0,0,0,50.076,9.008a11.482,11.482,0,0,0-20.39-1.484,11.529,11.529,0,0,0-7.957-2.5A11.7,11.7,0,0,0,11,16.83v.421A1.75,1.75,0,0,1,9.252,19a7.134,7.134,0,0,0-7.2,6.155A7,7,0,0,0,9,33ZM52.586,50,45,57.586,37.414,50H40a1,1,0,0,0,1-1V33h8V49a1,1,0,0,0,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M50,13.515a1,1,0,0,0,0,2,4,4,0,0,1,4,4,1,1,0,0,0,2,0A6.006,6.006,0,0,0,50,13.515Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M55,22a1,1,0,0,0-1,1v.515a1,1,0,0,0,2,0V23A1,1,0,0,0,55,22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M20.027,58.515a9,9,0,1,0-9-9A9.01,9.01,0,0,0,20.027,58.515Zm0-16a7,7,0,1,1-7,7A7.008,7.008,0,0,1,20.027,42.515Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M20.542,52H19.513a.486.486,0,0,1-.486-.485,1,1,0,0,0-2,0,2.489,2.489,0,0,0,2,2.436v.564a1,1,0,0,0,2,0v-.564a2.488,2.488,0,0,0,2-2.436,3,3,0,0,0-3-3,1.008,1.008,0,0,1-1-1.03A.486.486,0,0,1,19.513,47h1.029a.485.485,0,0,1,.485.485v.03a.988.988,0,0,0,1,.985,1.012,1.012,0,0,0,1-1.015,2.488,2.488,0,0,0-2-2.436v-.534a1,1,0,0,0-2,0v.534a2.5,2.5,0,0,0-2,2.466,3,3,0,0,0,3,3,1,1,0,0,1,1,1A.485.485,0,0,1,20.542,52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M14.027,36a1,1,0,0,0,2,0V31a1,1,0,0,0-2,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M15.027,28.515a1,1,0,0,0,1-1V27a1,1,0,0,0-2,0v.515A1,1,0,0,0,15.027,28.515Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M19,34a1,1,0,0,0,2,0V28a1,1,0,0,0-2,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M20,25.515a1,1,0,0,0,1-1V24a1,1,0,0,0-2,0v.515A1,1,0,0,0,20,25.515Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M24.027,36a1,1,0,0,0,2,0V32a1,1,0,0,0-2,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M25.027,29.515a1,1,0,0,0,1-1V28a1,1,0,0,0-2,0v.515A1,1,0,0,0,25.027,29.515Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M8,49.5a12,12,0,1,0,12-12A12.013,12.013,0,0,0,8,49.5Zm12-10a10,10,0,1,1-10,10A10.011,10.011,0,0,1,20,39.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M32.5,14A1.5,1.5,0,0,1,34,15.5a1,1,0,0,0,2,0,3.5,3.5,0,0,0-7,0v4a3.5,3.5,0,0,0,7,0,1,1,0,0,0-2,0,1.5,1.5,0,0,1-3,0v-4A1.5,1.5,0,0,1,32.5,14Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M44,19.5v-4a3.5,3.5,0,0,0-7,0v4a3.5,3.5,0,0,0,7,0Zm-5,0v-4a1.5,1.5,0,0,1,3,0v4a1.5,1.5,0,0,1-3,0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M45,22a1,1,0,0,0,2,0,1,1,0,1,1,1.6.8l-3.2,2.4A1,1,0,0,0,46,27h4a1,1,0,0,0,0-2H49l.8-.6A3,3,0,1,0,45,22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.53396149a8fb4c3fdda0e951c2ff0640.svg";
export { ForwardRef as ReactComponent };